import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/cartSlice';
import { translations } from '../utils/translations';
import './RmaModal.css';

const rmaTranslations = {
  en: {
    title: "RMA Claim Form",
    subtitle: "Return Merchandise Authorization",
    selectProduct: "Select Purchased Product",
    describeFault: "Describe the Fault/Issue",
    placeholderFault: "Please describe the fault in detail...",
    submit: "Submit RMA Claim",
    cancel: "Cancel",
    notLoggedIn: "Please log in to submit an RMA claim.",
    loginBtn: "Log In",
    noOrders: "No purchased products found for your account.",
    successTitle: "RMA Request Sent!",
    successText: "Our support team has received your claim and will contact you via email.",
    loading: "Submitting request...",
    errorTitle: "Submission Failed",
    errorText: "Failed to send RMA request. Please try again later.",
    selectPlaceholder: "-- Select a product --"
  },
  nl: {
    title: "RMA Claimformulier",
    subtitle: "Retour Goederen Autorisatie",
    selectProduct: "Selecteer Gekocht Product",
    describeFault: "Beschrijf het Defect / Probleem",
    placeholderFault: "Beschrijf de fout alstublieft in detail...",
    submit: "RMA-claim Indienen",
    cancel: "Annuleren",
    notLoggedIn: "Meld u aan om een RMA-claim in te dienen.",
    loginBtn: "Inloggen",
    noOrders: "Geen gekochte producten gevonden voor uw account.",
    successTitle: "RMA-aanvraag Verzonden!",
    successText: "Ons supportteam heeft uw claim ontvangen en neemt via e-mail contact met u op.",
    loading: "Aanvraag indienen...",
    errorTitle: "Indienen Mislukt",
    errorText: "RMA-aanvraag verzenden mislukt. Probeer het later opnieuw.",
    selectPlaceholder: "-- Selecteer een product --"
  },
  es: {
    title: "Formulario de Reclamación RMA",
    subtitle: "Autorización de Retorno de Mercancía",
    selectProduct: "Seleccionar Producto Comprado",
    describeFault: "Describir el Defecto / Problema",
    placeholderFault: "Por favor, describa el fallo en detalle...",
    submit: "Enviar Reclamación RMA",
    cancel: "Cancelar",
    notLoggedIn: "Inicie sesión para enviar una reclamación RMA.",
    loginBtn: "Iniciar sesión",
    noOrders: "No se encontraron productos comprados para su cuenta.",
    successTitle: "¡Solicitud RMA Enviada!",
    successText: "Nuestro equipo de soporte ha recibido su reclamación y se pondrá en contacto por correo electrónico.",
    loading: "Enviando solicitud...",
    errorTitle: "Envío Fallido",
    errorText: "Error al enviar la solicitud RMA. Inténtelo de nuevo más tarde.",
    selectPlaceholder: "-- Seleccionar un producto --"
  },
  fr: {
    title: "Formulaire de Réclamation RMA",
    subtitle: "Autorisation de Retour de Marchandise",
    selectProduct: "Sélectionner le Produit Acheté",
    describeFault: "Décrire la Panne / Problème",
    placeholderFault: "Veuillez décrire le problème en détail...",
    submit: "Soumettre la Réclamation RMA",
    cancel: "Annuler",
    notLoggedIn: "Veuillez vous connecter pour soumettre une réclamation RMA.",
    loginBtn: "Se Connecter",
    noOrders: "Aucun produit acheté trouvé pour votre compte.",
    successTitle: "Demande RMA Envoyée !",
    successText: "Notre équipe d'assistance a reçu votre réclamation et vous contactera par e-mail.",
    loading: "Soumission de la demande...",
    errorTitle: "Échec de la Soumission",
    errorText: "Échec de l'envoi de la demande RMA. Veuillez réessayer plus tard.",
    selectPlaceholder: "-- Sélectionner un produit --"
  },
  de: {
    title: "RMA-Reklamationsformular",
    subtitle: "Rücksendeautorisierung",
    selectProduct: "Gekauftes Produkt Auswählen",
    describeFault: "Beschreiben Sie den Fehler / Defekt",
    placeholderFault: "Bitte beschreiben Sie den Fehler im Detail...",
    submit: "RMA-Reklamation Absenden",
    cancel: "Abbrechen",
    notLoggedIn: "Bitte melden Sie sich an, um eine RMA-Reklamation einzureichen.",
    loginBtn: "Einloggen",
    noOrders: "Keine gekauften Produkte für Ihr Konto gefunden.",
    successTitle: "RMA-Anfrage Gesendet!",
    successText: "Unser Support-Team hat Ihre Reklamation erhalten und wird sich per E-Mail bei Ihnen melden.",
    loading: "Anfrage wird gesendet...",
    errorTitle: "Senden Fehlgeschlagen",
    errorText: "RMA-Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später noch einmal.",
    selectPlaceholder: "-- Produkt auswählen --"
  },
  it: {
    title: "Modulo di Reclamo RMA",
    subtitle: "Autorizzazione al Reso della Merce",
    selectProduct: "Seleziona Prodotto Acquistato",
    describeFault: "Descrivere il Guasto / Problema",
    placeholderFault: "Si prega di descrivere il guasto in dettaglio...",
    submit: "Invia Reclamo RMA",
    cancel: "Annulla",
    notLoggedIn: "Accedi per inviare un reclamo RMA.",
    loginBtn: "Accedi",
    noOrders: "Nessun prodotto acquistato trovato per il tuo account.",
    successTitle: "Richiesta RMA Inviata!",
    successText: "Il nostro team di supporto ha ricevuto il tuo reclamo e ti contatterà via e-mail.",
    loading: "Invio richiesta...",
    errorTitle: "Invio Fallito",
    errorText: "Impossibile inviare la richiesta RMA. Riprova più tardi.",
    selectPlaceholder: "-- Seleziona un prodotto --"
  },
  pt: {
    title: "Formulário de Reclamação RMA",
    subtitle: "Autorização de Retorno de Mercadoria",
    selectProduct: "Selecionar Produto Adquirido",
    describeFault: "Descrever a Avaria / Problema",
    placeholderFault: "Por favor, descreva a avaria em detalhe...",
    submit: "Enviar Reclamação RMA",
    cancel: "Cancelar",
    notLoggedIn: "Por favor, inicie sessão para enviar uma reclamação RMA.",
    loginBtn: "Iniciar Sessão",
    noOrders: "Nenhum produto adquirido encontrado para a sua conta.",
    successTitle: "Pedido RMA Enviado!",
    successText: "A nossa equipa de suporte recebeu a sua reclamação e entrará em contacto por e-mail.",
    loading: "A enviar pedido...",
    errorTitle: "Envio Falhou",
    errorText: "Falha ao enviar pedido RMA. Por favor, tente novamente mais tarde.",
    selectPlaceholder: "-- Selecionar um produto --"
  },
  el: {
    title: "Φόρμα Αίτησης RMA",
    subtitle: "Έγκριση Επιστροφής Εμπορευμάτων",
    selectProduct: "Επιλέξτε Αγορασμένο Προϊόν",
    describeFault: "Περιγράψτε τη Βλάβη / Πρόβλημα",
    placeholderFault: "Παρακαλούμε περιγράψτε τη βλάβη λεπτομερώς...",
    submit: "Υποβολή Αίτησης RMA",
    cancel: "Ακύρωση",
    notLoggedIn: "Παρακαλούμε συνδεθείτε για να υποβάλετε αίτηση RMA.",
    loginBtn: "Σύνδεση",
    noOrders: "Δεν βρέθηκαν αγορασμένα προϊόντα για το λογαριασμό σας.",
    successTitle: "Η Αίτηση RMA Στάλθηκε!",
    successText: "Η ομάδα υποστήριξης έλαβε το αίτημά σας και θα επικοινωνήσει μαζί σας μέσω email.",
    loading: "Υποβολή αιτήματος...",
    errorTitle: "Αποτυχία Υποβολής",
    errorText: "Αποτυχία αποστολής αιτήματος RMA. Παρακαλούμε δοκιμάστε ξανά αργότερα.",
    selectPlaceholder: "-- Επιλέξτε προϊόν --"
  }
};

const RmaModal = ({ isOpen, onClose }) => {
  const selectedLang = useSelector(selectLanguage) || { code: 'en' };
  const t = rmaTranslations[selectedLang.code || 'en'] || rmaTranslations.en;

  const [user, setUser] = useState(null);
  const [purchasedItems, setPurchasedItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState('');
  const [faultDesc, setFaultDesc] = useState('');
  const [loading, setLoading] = useState(false);
  const [fetchingProducts, setFetchingProducts] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    const session = localStorage.getItem('user_session');
    if (session) {
      const parsedUser = JSON.parse(session);
      setUser(parsedUser);
      loadPurchasedProducts(parsedUser.email);
    } else {
      setUser(null);
      setPurchasedItems([]);
    }
    setSelectedItem('');
    setFaultDesc('');
  }, [isOpen]);

  const loadPurchasedProducts = async (email) => {
    setFetchingProducts(true);
    try {
      const response = await fetch(`/api/orders/email/${encodeURIComponent(email)}`);
      if (response.ok) {
        const orders = await response.json();
        const items = [];
        if (Array.isArray(orders)) {
          orders.forEach(order => {
            if (order && order.items && Array.isArray(order.items)) {
              order.items.forEach(item => {
                if (item) {
                  items.push({
                    orderId: order._id || '',
                    productName: item.name || 'Unknown Product',
                    uniqueKey: `${order._id || 'order'}-${item.productId || item.name || Math.random()}`
                  });
                }
              });
            }
          });
        }
        setPurchasedItems(items);
      }
    } catch (error) {
      console.error("Error loading purchased items for RMA dropdown:", error);
    } finally {
      setFetchingProducts(false);
    }
  };

  const handleLoginRedirect = () => {
    onClose();
    window.history.pushState({}, '', '/login');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedItem || !faultDesc.trim()) return;

    setLoading(true);
    const selectedObj = purchasedItems.find(item => item.uniqueKey === selectedItem);

    try {
      const response = await fetch('/api/orders/rma', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: user.email,
          fullName: user.fullName,
          orderId: selectedObj.orderId,
          productName: selectedObj.productName,
          fault: faultDesc
        })
      });

      if (response.ok) {
        import('sweetalert2').then((Swal) => {
          Swal.default.fire({
            title: t.successTitle,
            text: t.successText,
            icon: 'success',
            confirmButtonColor: '#be1e2d'
          });
        });
        onClose();
      } else {
        throw new Error();
      }
    } catch (error) {
      import('sweetalert2').then((Swal) => {
        Swal.default.fire({
          title: t.errorTitle,
          text: t.errorText,
          icon: 'error',
          confirmButtonColor: '#be1e2d'
        });
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="rma-modal-overlay" onClick={onClose}>
      <div className="rma-modal-card animate-zoom-in" onClick={(e) => e.stopPropagation()}>
        <button className="rma-modal-close-btn" onClick={onClose} aria-label="Close modal">×</button>
        
        <div className="rma-modal-header">
          <div className="rma-modal-badge">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1l3.09 6.26L22 8.27l-5 4.87 1.18 6.88L12 16.9l-6.18 3.12L7 13.14 2 8.27l6.91-1.01L12 1z"/></svg>
            RMA
          </div>
          <h2 className="rma-modal-title">{t.title}</h2>
          <span className="rma-modal-subtitle">{t.subtitle}</span>
        </div>

        <div className="rma-modal-body">
          {!user ? (
            <div className="rma-state-box">
              <div className="rma-state-icon">🔒</div>
              <p className="rma-state-text">{t.notLoggedIn}</p>
              <button className="btn-rma-primary" onClick={handleLoginRedirect}>{t.loginBtn}</button>
            </div>
          ) : fetchingProducts ? (
            <div className="rma-state-box">
              <div className="rma-spinner"></div>
            </div>
          ) : purchasedItems.length === 0 ? (
            <div className="rma-state-box">
              <div className="rma-state-icon">📦</div>
              <p className="rma-state-text">{t.noOrders}</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="rma-form-element">
              <div className="rma-field-group">
                <label className="rma-field-label">{t.selectProduct}</label>
                <select
                  className="rma-form-select"
                  value={selectedItem}
                  onChange={(e) => setSelectedItem(e.target.value)}
                  required
                >
                  <option value="">{t.selectPlaceholder}</option>
                  {purchasedItems.map((item) => (
                    <option key={item.uniqueKey} value={item.uniqueKey}>
                      {item.productName} (Order #{item.orderId.substring(item.orderId.length - 8).toUpperCase()})
                    </option>
                  ))}
                </select>
              </div>

              <div className="rma-field-group">
                <label className="rma-field-label">{t.describeFault}</label>
                <textarea
                  className="rma-form-textarea"
                  value={faultDesc}
                  onChange={(e) => setFaultDesc(e.target.value)}
                  placeholder={t.placeholderFault}
                  rows="4"
                  required
                />
              </div>

              <div className="rma-divider"></div>

              <div className="rma-actions-row">
                <button type="button" className="btn-rma-secondary" onClick={onClose}>{t.cancel}</button>
                <button type="submit" className="btn-rma-primary" disabled={loading || !selectedItem || !faultDesc.trim()}>
                  {loading ? (
                    <>
                      <svg style={{display:'inline',marginRight:6,verticalAlign:'middle'}} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
                      {t.loading}
                    </>
                  ) : t.submit}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default RmaModal;
